<template>
	<component :key="key" :is="formModule.component" :name="formModule.name"  :title="formModule.title" :id="formModule.id" :extra="formModule.extra" />
</template>
<style scoped>


</style>
<script>
	import loginMixins from '@_system/components/base/mixins/login/login.js'
	export default {
		mixins: [loginMixins],
		props: {
			custompageConfig: {
				type: Object,
				default: () => {
					return {
						name: '',
						title: '自定义页面',
						penetrateName: '自定义页面',
						id: 0,
					}
				}
			},

		},
		data() {
			return {
				key: Math.random(),
				formModule:{
					component: null,
					name: null,
					title:null,
					id:0
				},
			}
		},
		watch: {

		},
		computed: {
			custompageMap() {
				return this.$store.state.custompageMap
			}
		},
		created() {
		
			//this.formModule = this.penetrateConfig
		},
		mounted() {
			if (!this.$store.state.system.systemdata) {
				this.login_init()
			}else{
				this.login_handle()
			}
		},
		methods: {
			login_after() {
				this.load()
			},	
			load() {
				if (this.custompageMap[this.custompageConfig.name]) {
					window.document.title = this.custompageConfig.title
					this.init()
				} else {
					this.$emit('back', 'cancle')
					this.$message.error('自定义页面不存在')
				}
			},
			initList() {

			},
			init() {
				import(`@/${this.custompageMap[this.custompageConfig.name]}`).then((res) => {
					this.formModule = {
						component: res.default,
						name: this.custompageConfig.name,
						title:this.custompageConfig.title,
						id:this.custompageConfig.id,
						extra:this.custompageConfig.extra
					}
					//console.log(this.formModule)
					
				})
			},
			formBack(e) {
				this.$emit('back', e)
			}
		}
	}
</script>
